import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Close } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { tailwindMerge } from "@air/tailwind-variants";
import * as RadixDialog from "@radix-ui/react-dialog";
import { memo } from "react";
export const ActionSheetHeader = /*#__PURE__*/ memo((param)=>{
    let { children, className, onClose, ...restOfProps } = param;
    return /*#__PURE__*/ _jsxs("header", {
        className: tailwindMerge("-mx-2 -mt-2 flex h-14 shrink-0 items-center justify-between gap-2 border-b border-b-grey-5 px-4", className),
        ...restOfProps,
        children: [
            /*#__PURE__*/ _jsx(RadixDialog.Title, {
                className: "text-16 font-semibold text-grey-11",
                children: children
            }),
            !!onClose && /*#__PURE__*/ _jsx(IconButton, {
                appearance: "ghost",
                color: "grey",
                icon: Close,
                label: "Close",
                onClick: onClose,
                size: "medium"
            })
        ]
    });
});
ActionSheetHeader.displayName = "ActionSheetHeader";
